<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        d="M256.14,324.07v12.21q0,42.08,0,84.15c0,10.23,4.41,18.14,13.93,21.91,9.29,3.69,18,1.91,25.41-5.48Q377.38,354.93,459.29,273c10.81-10.86,10.76-23.33,0-34.14q-81.41-81.7-163.12-163.09c-7.5-7.5-16.46-10.19-26.21-6.06s-14,12.25-13.89,23c.21,28.05.07,56.1.07,84.15V188.1h-12q-86.13,0-172.26,0c-18.74,0-27.15,8.41-27.22,27.2-.09,25.41,0,50.82,0,76.23,0,25.59,6.83,32.51,32.08,32.52H256.14Z"
        style="fill:#fff"
      />
      <path
        d="M256.14,324.07H76.73c-25.25,0-32.08-6.93-32.08-32.52,0-25.41-.07-50.82,0-76.23.07-18.79,8.48-27.19,27.22-27.2q86.13-.08,172.26,0h12V176.87c0-28.05.14-56.1-.07-84.15C256,82,260.23,73.85,270,69.73s18.71-1.44,26.21,6.06q81.58,81.52,163.12,163.09c10.76,10.81,10.81,23.28,0,34.14q-81.72,82.1-163.78,163.84c-7.38,7.39-16.12,9.17-25.41,5.48-9.52-3.77-13.92-11.68-13.93-21.91q0-42.07,0-84.15Z"
      />
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
